module.exports = __webpack_public_path__ + "img/DW365-130.ccf87841.jpg";